<template>
<div class="left-right-layout mam-master-trading-cycle">
<!--  改为左右布局: pc端: 左边固定未260: 右边不变化,右边的表格宽度有个最小宽度,
移动端完全不一样,:  左边栏变成了右边出的抽屉弹框,-->
  <div class="mobile-top-bar">
    <div class="issue-box">
      <span class="issue">{{currentTradeCycle.issueNumber || $t('copyMaster.No_trading_cycle_yet')}}</span>
      <span
        v-if="currentTradeCycle.issueNumber"
        class="tag-box status"
        :style="getStyle(currentTradeCycle.status)"
      >{{getStaus(currentTradeCycle.status)}}</span>
    </div>
    <span
      class="el-icon-arrow-right"
      @click="mobileCycleHandle"
    ></span>
  </div>
  <div class="layout-under-content pr">
    <div class="layout-under-left hidden-xs-only">
      <div class="left-header header-top">
        <span class="title">{{$t('Trading_cycle')}}</span>
<!--
v-if="statistics.userStatus !== 0 && statistics.userStatus == 3"
 需要判断和传参数
-->
<!--        -->
        <start-btn
          v-if="statistics.userStatus == 3"
          :mt-id="+$route.params.mtid"
          @startUsing-success="changeRefresh"
        ></start-btn>
      </div>
      <trade-cycle-sider-bar
        ref="pcsiderbar"
        class=""
        @current-tradeCycle="acceptCurrentTradeCycle"
      ></trade-cycle-sider-bar>
    </div>
    <div class="layout-under-right">
      <div class="right-header header-top">
        <span class="title">{{$t('details')}}</span>
        <span
          v-if="statistics.userStatus !== 0 && currentTradeCycle.status !== 3"
        >
          <el-tooltip
            class="item"
            effect="dark"
            placement="top"
            v-if="setBtnShow"
          >
          <div
            slot="content"
            class="content"
            style="width: 136px;"
          >
            <p class="">{{$t('Settlement_conditions')}}：</p>
            <p>1.{{$t('cycleTips1')}}</p>
            <p>2.{{$t('cycleTips2')}}</p>
          </div>
          <el-button
            v-if="statistics.userStatus != 1 && statistics.userStatus !==3"
            size="small"
            class="disabled-btn"
            type="primary"
          >{{$t('settle')}}</el-button>
        </el-tooltip>
          <el-button
          v-if="statistics.userStatus == 1 && statistics.userStatus !==3 "
          size="small"
          type="primary"
          :loading="settleLoading"
          @click="settleHandle"
        >{{$t('settle')}}</el-button>
        </span>
      </div>
      <VuePerfectScrollbar
        class="scroll-area--customizer"
        :settings="settings"
        :key="$vs.rtl"
      >
        <div class="right-content">
          <right-content
            :row-data="currentTradeCycle"
          ></right-content>
        </div>
      </VuePerfectScrollbar>
    </div>
  </div>

  <mobile-trade-cycle-sider-bar
    ref="mobilesiderbar"
      @current-tradeCycle="acceptCurrentTradeCycle"
      :dialog-show="mobileTradeCycleSiderBarDialogShow"
      @close="mobileTradeCycleSiderBarDialogShow = false"
    @startUsing-success="startUsingSuccess"
  ></mobile-trade-cycle-sider-bar>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import startBtn from "@/components/user/details/mamMaster/tradingCycle/startBtn";
import { getStaus,getStyle } from "@/components/user/details/mamMaster/tradingCycle/utils";
import { addTradingCycle, settle } from "@/api/copy";

import mobileTradeCycleSiderBar from "@/components/user/details/mamMaster/tradingCycle/mobileTradeCycleSiderBar";
import rightContent from "@/components/user/details/mamMaster/tradingCycle/rightContent";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import tradeCycleSiderBar from "@/components/user/details/mamMaster/tradingCycle/tradeCycleSiderBar";
import transactionPeriodMamMaster from '@/components/user/details/mamMaster/overview/transactionPeriod/transactionPeriodMamMaster'

export default {
  name: "index",
  components: {
    tradeCycleSiderBar,
    VuePerfectScrollbar,
    rightContent,
    mobileTradeCycleSiderBar,
    startBtn,
  },
  data() {
    return {
      settleLoading: false,
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      mobileTradeCycleSiderBarDialogShow: false,
      currentTradeCycle:{
        issueNumber: '',
        managementProfit: '',
      },
      statistics:{
        userStatus: 0,
        times: 0
      },
    }
  },
  computed:{
    ...mapGetters(['realMobile']),
    setBtnShow(){
      return this.statistics.userStatus != 1 && this.statistics.userStatus !==3;
    }
  },
  mounted(){
    let reouterview = document.getElementById('body');
    reouterview.classList.add('hidden-scroll');

    let wrapper = document.getElementById('contentwrapper');
    wrapper.classList.add('content-wrapper-special');
  },
  beforeDestroy(){
    let reouterview = document.getElementById('body');
    reouterview && reouterview.classList.remove('hidden-scroll');

    let wrapper = document.getElementById('contentwrapper');
    wrapper && wrapper.classList.remove('content-wrapper-special');
  },
  methods: {
    getStaus,
    getStyle,
    mobileCycleHandle(){
      this.mobileTradeCycleSiderBarDialogShow = true;
    },
    acceptCurrentTradeCycle(currentTradeCycle,statistics){
      if(currentTradeCycle){
        this.currentTradeCycle = currentTradeCycle;
      }
      this.statistics = statistics;
    },
    changeRefresh(){
      if(!this.realMobile){
        this.$refs.pcsiderbar.getData();
      }else {
        this.$refs.mobilesiderbar.$refs.siderbarinner.getData();
      }
    },
    settleHandle(){
      // 1判断是否少于15天
      // 2判断是否账户未空仓
      if(this.statistics.times < 15){
        this.$message({
          type: 'warning',
          message: this.$t('cycleTips1') + '，' + this.$t('Settlement_not_supported'),
        });
        return;
      }
      this.$confirm(this.$t('settleBeforeTips'), this.$t('Confirm_settlement'), {
        confirmButtonText: this.$t('root.confirm'),
        cancelButtonText: this.$t('root.cancle'),
        type: 'warning',
        customClass: 'self-messagebox-wrapper'
      }).then(() => {
        this.settleLoading = true;
        settle({
          mtId: +this.$route.params.mtid,
        }).then((res) => {
          this.settleLoading = false;
          this.$message({
            message:this.$t('withgold.operatingSuccess'),
            type: 'success'
          });
          this.changeRefresh(); // 结算和开启都需要刷新下 todo
          this.$store.commit('setListRefresh', !this.listRefresh);
        }).catch((error) => {
          this.settleLoading = false;
        })
      }).catch(() => {
        //几点取消的提示
      });
    },

    startUsingSuccess(){
      this.changeRefresh();
      this.mobileTradeCycleSiderBarDialogShow = false;
    },
  },
}
</script>

<style lang="scss" scoped>
.mam-master-trading-cycle {
  .disabled-btn {
    background-color: #B9B9C3;
    border-color: #B9B9C3;
    cursor: not-allowed;
  }
  .scroll-area--customizer {

  }
}
</style>
<style lang="scss">
.hidden-scroll {
  overflow-y: hidden;
}
</style>
